import * as React from "react";
import styled from "styled-components";

import { Button, Card, Text } from "../../../../components/atoms";
import { Input } from "../../../../components/molecules";

interface IProps {
  codeValue: string;
  isLoggedIn: boolean;
  isButtonDisabled: boolean;
  onInputChange(e: React.ChangeEvent<HTMLInputElement>): void;
  onSubmit(): void;
  promocodeError?: string;
}

const OrderPromoCard = Card.extend`
  width: auto;
  height: auto;
  padding: 17px 26px;
`;

const OrderPromoHeader = Text.extend`
  padding-bottom: 24px;
`;

const OrderPromoButton = styled(Button)`
  width: 100%;
`;

const OrderPromoSection = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 16px;
`;

const OrderPromoSectionInput = styled(Input)`
  width: 100%;
`;

const OrderPromoWrapper = styled.div`
  margin-top: 16px;
`;

const OrderPromo: React.FC<IProps> = (props) => {
  return (
    <OrderPromoWrapper>
      {props.isLoggedIn && (
        <React.Fragment>
          <OrderPromoCard>
            <OrderPromoHeader size="20" weight="bold" transform="uppercase">
              Voucher / Promo Code
            </OrderPromoHeader>
            <React.Fragment>
              <OrderPromoSection>
                <OrderPromoSectionInput
                  type="text"
                  label="Code"
                  placeholder="&bull; &bull; &bull; &bull; &bull;"
                  onChange={props.onInputChange}
                  value={props.codeValue}
                />
              </OrderPromoSection>
              <OrderPromoSection>
                <OrderPromoButton
                  background="grey"
                  size="small"
                  onClick={props.onSubmit}
                  disabled={props.isButtonDisabled}
                >
                  Submit
                </OrderPromoButton>
              </OrderPromoSection>
            </React.Fragment>
            {props.promocodeError && (
              <OrderPromoSection>
                <Text size="18">{props.promocodeError}</Text>
              </OrderPromoSection>
            )}
          </OrderPromoCard>
        </React.Fragment>
      )}
    </OrderPromoWrapper>
  );
};

export { OrderPromo };
